<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<!--testimonial style1 start-->

<section class="slider-sec">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="owl-carousel no-pb" data-dots="false" data-nav="true" data-items="1" data-autoplay="true">
          <div class="item">
            <div class="testimonial" data-bg-img="images/pattern/03.png">
              <div class="testimonial-img" data-bg-img="images/testimonial/01.jpg">
                <img class="img-fluid" src="images/testimonial/01.jpg" alt="">
              </div>
              <div class="testimonial-content">
                <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                <p>Eeque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</p>
                <div class="testimonial-caption">
                  <h5>Alvi Miller</h5>
                  <label>Founder of Agencio</label>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="testimonial" data-bg-img="images/pattern/03.png">
              <div class="testimonial-img">
                <img class="img-fluid" src="images/testimonial/02.jpg" alt="">
              </div>
              <div class="testimonial-content">
                <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                <p>Reasonable porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam tempora</p>
                <div class="testimonial-caption">
                  <h5>Albert Jonson</h5>
                  <label>CEO of Agencio</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--testimonial style1 end-->


<!--testimonial style2 start-->

<section class="pb-0 pos-r" data-bg-img="images/bg/06.png">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="owl-carousel" data-items="2" data-md-items="2" data-sm-items="1" data-autoplay="true">
          <div class="item">
            <div class="testimonial style-2">
                  <div class="testimonial-content">
                    <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                    <p>Eeque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</p>
                  </div>
                  <div class="d-sm-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/01.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Alvi Miller</h5>
                      <label>Founder of Agencio</label>
                    </div>
                  </div>
                </div>
          </div>
          <div class="item">
            <div class="testimonial style-2">
                  <div class="testimonial-content">
                    <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                    <p>Reasonable porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam tempora</p>
                  </div>
                  <div class="d-sm-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/02.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Albert Jonson</h5>
                      <label>CEO of Agencio</label>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--testimonial style2 end-->


<!--testimonial style3 start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="owl-carousel" data-items="1" data-autoplay="true">
          <div class="item">
            <div class="row no-gutters align-items-center">
              <div class="col-md-5">
                <div class="theme-bg text-center p-3 position-absolute z-index-1"><i class="flaticon-left-quote h2 text-white mb-0"></i>
                </div>
                <img class="img-fluid mt-4 mr-md-4 box-shadow" src="images/testimonial/01.jpg" alt="">
              </div>
              <div class="col-md-7 mr-md-n5 mt-n5 mt-md-0">
                <div class="testimonial style-3">
                  <div class="testimonial-content">
                    <p>Eeque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/01.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Alvi Miller</h5>
                      <label>Founder of Agencio</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row no-gutters align-items-center">
              <div class="col-md-5">
                <div class="theme-bg text-center p-3 position-absolute z-index-1"><i class="flaticon-left-quote h2 text-white mb-0"></i>
                </div>
                <img class="img-fluid mt-4 mr-md-4 box-shadow" src="images/testimonial/02.jpg" alt="">
              </div>
              <div class="col-md-7 mr-md-n5 mt-n5 mt-md-0">
                <div class="testimonial style-3">
                  <div class="testimonial-content">
                    <p>Reasonable porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam tempora</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/02.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Albert Jonson</h5>
                      <label>CEO of Agencio</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--testimonial style3 end-->


<!--testimonial style4 start-->

<section>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-12">
        <div class="box-shadow p-3 p-md-5 pos-r">
          <div class="img-bg">
            <svg class="morph-shape" viewBox="0 0 500 500">
              <defs>
                <linearGradient id="main-gradien2" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="10%" style="stop-color:#0083ff;"></stop>
                  <stop offset="100%" style="stop-color:#00f2aa;"></stop>
                </linearGradient>
              </defs>
              <path id="object2" class="js-items-shape-path" fill="url(#main-gradien2)" d="M418.1 159.8 C460.9 222.9 497 321.5 452.4 383.4 417.2 432.4 371.2 405.6 271.3 420.3 137.19 440 90.45 500.6 42.16 442.8 -9.57 381 86.33 289.1 117.7 215.5 144.3 153.4 145.69 54.21 212.7 36.25 290.3 15.36 373.9 94.6 418.1 159.8 " data-original="M 418.1,159.8 C 460.9,222.9 497,321.5 452.4,383.4 417.2,432.4 371.2,405.6 271.3,420.3 137.2,440 90.45,500.6 42.16,442.8 -9.572,381 86.33,289.1 117.7,215.5 144.3,153.4 145.7,54.21 212.7,36.25 290.3,15.36 373.9,94.6 418.1,159.8 Z"></path>
            </svg>
          </div>
          <div class="owl-carousel" data-items="1" data-autoplay="true">
            <div class="item">
              <div class="testimonial style-3 shadow-none">
                <div class="testimonial-content">
                  <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                  </div>
                  <p>Eeque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</p>
                </div>
                <div class="d-sm-flex align-items-center">
                  <div class="testimonial-img">
                    <img class="img-fluid" src="images/testimonial/01.jpg" alt="">
                  </div>
                  <div class="testimonial-caption">
                    <h5>Alvi Miller</h5>
                    <label>Founder of Agencio</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="testimonial style-3 shadow-none">
                <div class="testimonial-content">
                  <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                  </div>
                  <p>Reasonable porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam tempora</p>
                </div>
                <div class="d-sm-flex align-items-center">
                  <div class="testimonial-img">
                    <img class="img-fluid" src="images/testimonial/02.jpg" alt="">
                  </div>
                  <div class="testimonial-caption">
                    <h5>Albert Jonson</h5>
                    <label>CEO of Agencio</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--testimonial style4 end-->

</div>

<!--body content end--> 
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            name: "shortcode-testmonials",
        }
    }
}
</script>